module.exports = __webpack_public_path__ + "static/media/miniLogo1.b2c3b6d0.svg";